(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2284],{

/***/ 8332:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/all",
      function () {
        return __webpack_require__(37642);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 37642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18256);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1860);
/* harmony import */ var _components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56951);
/* harmony import */ var _components_templates_index_partials_InlineStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53408);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83974);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28207);
// import TagManager from "react-gtm-module";










var IndexSections = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3098), __webpack_require__.e(77), __webpack_require__.e(2817), __webpack_require__.e(9445), __webpack_require__.e(5175), __webpack_require__.e(4795), __webpack_require__.e(2368), __webpack_require__.e(6171), __webpack_require__.e(5885), __webpack_require__.e(9350), __webpack_require__.e(8630), __webpack_require__.e(5847)]).then(__webpack_require__.bind(__webpack_require__, 18364));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18364)
            ];
        }
    },
    suspense: true
});
var Addons = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8545).then(__webpack_require__.bind(__webpack_require__, 88545));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88545)
            ];
        }
    }
});
var Scripts = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
function Home(props) {
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .page */ .M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (window !== undefined) {
            setUrlHref(window.location.href);
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app = props.app;
    var builder = app.builder;
    var head = props.head;
    var footer = props.footer;
    var app_data = props.app_data;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var html_sections = props.html_sections;
    var script_sections = props.script_sections;
    var distincts = props.distincts;
    var profile = props.profile;
    var destinations = props.destinations;
    var collections = props.collections;
    var isDesktop = props.isDesktop;
    var image_fb_meta = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_6__/* ["default"].isValidArray */ .Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_index_partials_InlineStyles__WEBPACK_IMPORTED_MODULE_5__/* .InlineStyles */ .f, {
                app: app,
                rgbDesignColor: rgbDesignColor,
                rgbSearchbarColor: rgbSearchbarColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: head.data.title + " - " + head.data.motto + " | Home",
                keywords: head.data.meta_keywords,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                icon_60: head.data.icon_60,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: head.data.title + " - " + head.data.motto,
                desc_fb_meta: head.data.meta_description,
                image_fb_meta: image_fb_meta,
                site_name_fb_meta: head.data.title,
                lat_fb_meta: head.location.latitude,
                lon_fb_meta: head.location.longitude,
                twitter_img_alt: head.data.title + " - " + head.data.motto + ". " + head.data.meta_description,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location.address,
                googleSchemaCity: head.location.city,
                googleSchemaCountry: head.location.country,
                googleSchemaZip: head.location.zip,
                googleSchemaPhone: head.location.phone,
                designColor: app.designColor,
                font: app.font,
                manager: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IndexSections, {
                    isDesktop: isDesktop,
                    html_sections: html_sections.hasOwnProperty("app_sections") ? html_sections.app_sections != null && html_sections.app_sections.length > 0 ? html_sections.app_sections : null : null,
                    app_data: app_data,
                    head: head,
                    app: app,
                    builder: builder,
                    navigation: navigation,
                    content: content,
                    locations: locations,
                    footer: footer,
                    distincts: distincts,
                    profile: profile,
                    destinations: destinations,
                    collections: collections,
                    isHomepage: false,
                    categoriesContentDefault: null,
                    categoriesContentPromoted: null,
                    categoriesContentPromoted2: null
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Addons, {
                script_sections: script_sections.hasOwnProperty("app_sections") ? script_sections.app_sections != null && script_sections.app_sections.length > 0 ? script_sections.app_sections : null : null
            })
        ]
    }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5693,4285,8201,8340,9007,5553,5634,9656,8024,6442,8207,1345,9774,2888,179], function() { return __webpack_exec__(8332); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);